import { ActivityFlags } from './ActivityFlags';

export const ActivityLinks = {
    hotel: {
        trackerKey: ActivityFlags.shangrilaLinkClicked,
        linkText: 'Shangri-La Boracay',
        url: 'https://www.shangri-la.com/boracay/boracayresort/',
    },
    visa: {
        trackerKey: ActivityFlags.visaLinkClicked,
        linkText: 'PH Visa Policy',
        url: 'https://en.wikipedia.org/wiki/Visa_policy_of_the_Philippines',
    },
    passport: {
        trackerKey: ActivityFlags.renewPassportLinkClicked,
        linkText: 'Renew Passport (USA)',
        url: 'https://travel.state.gov/content/travel/en/passports/have-passport/renew-online.html', 
    }
};